import { Tag, type IconName, type TagVariant } from '@dev-spendesk/grapes';
import { type TFunction } from 'i18next';
import { type ReactNode } from 'react';

import type { InconsistencyMatchingResult } from 'src/core/modules/verification-of-payee/models';
import { useVerificationOfPayeeTranslations } from 'src/core/modules/verification-of-payee/translations/translations';

import './InconsistencyModalItem.css';

type Props = {
  itemSummary: ReactNode;
  matchingResult: InconsistencyMatchingResult;
};

type TagProps = {
  variant: TagVariant;
  iconName: IconName;
  label: string;
};

const getTagProps = (
  matchingResult: InconsistencyMatchingResult,
  t: TFunction,
): TagProps => {
  switch (matchingResult) {
    case 'close_match':
      return {
        variant: 'warning',
        iconName: 'triangle-warning',
        label: t('inconsistencyModal.payment.partialMatch'),
      };
    case 'no_match':
      return {
        variant: 'alert',
        iconName: 'hexagone-cross',
        label: t('inconsistencyModal.payment.noMatch'),
      };
    case 'impossible_match':
      return {
        variant: 'alert',
        iconName: 'hexagone-cross',
        label: t('inconsistencyModal.payment.impossibleMatch'),
      };
    default:
      throw new Error(`Invalid matching result: ${matchingResult}`);
  }
};

export const InconsistencyModalItem = ({
  itemSummary,
  matchingResult,
}: Props) => {
  const { t } = useVerificationOfPayeeTranslations();
  const { variant, iconName, label } = getTagProps(matchingResult, t);

  return (
    <div className="inconsistency-modal-content-line bg-background-secondary-default border-border-default border">
      {itemSummary}
      <Tag variant={variant} iconName={iconName}>
        {label}
      </Tag>
    </div>
  );
};
